import { motion } from "framer-motion";

export const EASE = [0.22, 1, 0.36, 1];

export const Reveal = ({
    children,
    delay = 0,
    y = 28,
    className = "",
    once = true,
}) => (
    <motion.div
        initial={{ opacity: 0, y }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once, amount: 0.05 }}
        transition={{ duration: 0.9, delay, ease: EASE }}
        className={className}
    >
        {children}
    </motion.div>
);

// Masked line reveal — the signature headline moment. Use `load` for above-the-fold
// headlines so the reveal fires on mount rather than waiting for a scroll event.
export const MaskedLine = ({ children, delay = 0, className = "", load = false }) => {
    const trigger = load
        ? { animate: { y: "0%" } }
        : { whileInView: { y: "0%" }, viewport: { once: true, amount: 0.05 } };
    return (
        <span className={`mask-line ${className}`}>
            <motion.span
                initial={{ y: "112%" }}
                transition={{ duration: 1.1, delay, ease: EASE }}
                className="block will-change-transform"
                {...trigger}
            >
                {children}
            </motion.span>
        </span>
    );
};

// Section chapter header — numbered editorial chapter device.
export const SectionHeading = ({
    index,
    eyebrow,
    title,
    intro,
    dark = false,
    aside = null,
}) => (
    <div className={dark ? "text-ivory" : "text-charcoal"}>
        <Reveal>
            <div
                className={`flex items-end justify-between gap-8 border-t pt-6 ${
                    dark ? "border-ivory/20" : "border-pine/15"
                }`}
            >
                <p
                    className={`eyebrow flex items-center gap-3 ${
                        dark ? "text-natural" : "text-moss"
                    }`}
                >
                    <span className="font-serif italic text-base tracking-normal">
                        {index}
                    </span>
                    {eyebrow}
                </p>
                {aside}
            </div>
        </Reveal>
        <Reveal delay={0.08}>
            <h2 className="font-serif font-medium text-4xl sm:text-5xl lg:text-[3.4rem] leading-[1.06] tracking-tight mt-6 max-w-3xl">
                {title}
            </h2>
        </Reveal>
        {intro && (
            <Reveal delay={0.16}>
                <p
                    className={`mt-6 text-base sm:text-lg leading-relaxed max-w-2xl ${
                        dark ? "text-ivory/70" : "text-moss"
                    }`}
                >
                    {intro}
                </p>
            </Reveal>
        )}
    </div>
);
